import React from "react";
import {
	InputField,
	SelectField,
	SelectFieldStatus,
	CustomDateField,
	DateTimeInputField,
} from "../../../components/Form/FormComponents";
import { getFormattedDate } from "../../../utils/DateUtils";
import { getApprovalStatus, getLeasorName } from "../../lease/utils";
import { getUserName } from "../../../utils/Utils";
import { repairStatusOptions } from "../data";
import { useParams } from "react-router-dom";
import FileUpload from "./FileUpload";

/* eslint-disable react/prop-types */

export const RequestInformationLease = ({
	formData,
	handleInputChange,
	isEditable,
	showDeliveryDetails,
	handleFileUpload,
	fileInfo,
	miniInfo,
	hardCopyReceipt,
	invoiceLoading,
	receiptLoading,
	fileOneEnabled,
	fileTwoEnabled,
}) => {
	const { id } = useParams();

	const requestStatus = formData?.usersRequest?.find((a) => a?.transactionId === id);

	const leaseStatus = getApprovalStatus(formData, requestStatus);

	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>
			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + id} />
			</div>
			<div className='form-group'>
				<label>ASSET</label>
				<InputField name='productName' value={formData?.productName} />
			</div>
			<div className='form-group'>
				<label>LEASOR</label>
				<InputField name='leasor' value={getLeasorName(formData)} />
			</div>
			<div className='form-group'>
				<label>LEASEE</label>
				<InputField name='leasee' value={getUserName(formData)} />
			</div>
			<div className='form-group'>
				<label>LEASE TYPE</label>
				<SelectField name='leaseType' value={formData?.leaseType} />
			</div>
			<div className='form-group'>
				<label>CATEGORY</label>
				<InputField name='productCategory' value={formData?.productCategory} />
			</div>
			<div className='form-group'>
				<label>BRAND</label>
				<InputField name='brand' value={formData?.brand} />
			</div>
			<div className='form-group'>
				<label>MODEL</label>
				<InputField name='model' value={formData?.model} />
			</div>
			<div className='form-group'>
				<label>YEAR</label>
				<InputField name='year' value={formData?.year} />
			</div>
			<div className='form-group'>
				<label>CONDITION</label>
				<InputField name='condition' value={formData?.condition} />
			</div>
			<div className='form-group'>
				<label>COLOR</label>
				<InputField name='color' value={formData?.color} />
			</div>
			<div className='form-group'>
				<label>DATE OF AGREEMENT</label>
				<InputField name='color' value={new Date(`${formData?.leaseAgreement?.date}`).toDateString()} />
			</div>
			<div className='form-group'>
				<label>LOGISTIC STATUS</label>
				<SelectField name='logistic status' value={formData?.logisticStatus || "N/A"} />
			</div>
			<div className='form-group'>
				<label>APPROVAL</label>
				<SelectFieldStatus name='approvalStatus' type={leaseStatus} value={leaseStatus} />
			</div>
			{showDeliveryDetails && formData?.productObj?.category === "Vehicles" && (
				<>
					<div className='form-group'>
						<label>ENGINE NO.</label>
						<InputField
							name='engineNum'
							value={miniInfo?.engineNum}
							isEditable={isEditable && !formData?.logisticStatus}
							handleChange={handleInputChange}
						/>
					</div>
					<div className='form-group'>
						<label>CHASSIS NO.</label>
						<InputField
							name='chassisNum'
							value={miniInfo?.chassisNum}
							isEditable={isEditable && !formData?.logisticStatus}
							handleChange={handleInputChange}
						/>
					</div>
				</>
			)}
			<div className='form-group'>
				<label>ASSET INVOICE</label>
				<FileUpload
					name='assetInvoice'
					isDisabled={!fileOneEnabled}
					isLoading={invoiceLoading}
					handleChange={handleFileUpload}
					fileInfo={fileInfo}
				/>
			</div>
			{formData?.logisticStatus && (
				<div className='form-group'>
					<label>HARD COPY RECEIPT</label>
					<FileUpload
						name='hardCopyReceipt'
						isDisabled={!fileTwoEnabled}
						isLoading={receiptLoading}
						handleChange={handleFileUpload}
						fileInfo={hardCopyReceipt}
					/>
				</div>
			)}

			{/* <div className='form-group'>
				<label>PAYMENT</label>
				<SelectFieldStatus
					name='paymentStatus'
					value={formData?.paymentStatus}
					type={formData?.paymentStatus?.toLowerCase()}
					options={["SETTLED", "DEFAULT"]}
				/>
			</div> */}
		</>
	);
};

export const RepairInformationLease = ({ formData, isEditable, handleInputChange }) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>ASSET</label>
				<InputField name='productName' value={formData?.productName} />
			</div>

			<div className='form-group'>
				<label>LEASEE</label>
				<InputField name='leasee' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>CONDITION</label>
				<InputField name='condition' value={formData?.condition} />
			</div>

			<div className='form-group'>
				<label>CATEGORY</label>
				<InputField name='productCategory' value={formData?.productCategory} />
			</div>

			<div className='form-group'>
				<label>PRICE</label>
				<InputField name='amount' value={formData?.amount} />
			</div>

			<div className='form-group'>
				<label>LEASE STRUCTURE</label>
				<InputField name='leaseStructure' value={formData?.leaseStructure} />
			</div>

			<div className='form-group'>
				<label>FAULT</label>
				<InputField
					name='fault'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.fault}
				/>
			</div>

			<div className='form-group'>
				<label>REPAIRS FEE</label>
				<InputField
					name='repairFee'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.repairFee}
				/>
			</div>

			<div className='form-group'>
				<label>ESTIMATED REPAIR DUE DATE</label>
				<DateTimeInputField
					name='repairDueDateIP'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.repairDueDateIP || formData?.repairDueDate?.iso}
					type='date'
				/>
			</div>

			<div className='form-group'>
				<label>STATUS</label>
				<SelectFieldStatus
					name='repairStatus'
					value={formData?.repairStatus}
					handleChange={handleInputChange}
					isEditable={isEditable}
					type={formData?.repairStatus?.toLowerCase()}
					options={repairStatusOptions}
				/>
			</div>
		</>
	);
};

// eslint-disable-next-line no-unused-vars
export const RetainedInformationLease = ({ formData, isEditable, handleInputChange }) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>ASSET</label>
				<InputField name='productName' value={formData?.productName} />
			</div>

			<div className='form-group'>
				<label>LEASOR</label>
				<InputField name='leasor' value={getLeasorName(formData)} />
			</div>

			<div className='form-group'>
				<label>LEASEE</label>
				<InputField name='leasee' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>CATEGORY</label>
				<InputField name='productCategory' value={formData?.productCategory} />
			</div>

			<div className='form-group'>
				<label>SUB-CATEGORY</label>
				<InputField name='subCategory' value={formData?.subCategory} />
			</div>

			<div className='form-group'>
				<label>PRICE</label>
				<InputField name='amount' value={formData?.price} />
			</div>

			<div className='form-group'>
				<label>BRAND</label>
				<InputField name='brand' value={formData?.brand} />
			</div>

			<div className='form-group'>
				<label>MODEL</label>
				<InputField name='model' value={formData?.model} />
			</div>

			<div className='form-group'>
				<label>YEAR</label>
				<InputField name='year' value={formData?.year} />
			</div>

			<div className='form-group'>
				<label>CONDITION</label>
				<InputField name='condition' value={formData?.condition} />
			</div>

			<div className='form-group'>
				<label>COLOR</label>
				<InputField name='color' value={formData?.color} />
			</div>

			<div className='form-group'>
				<label>LEASE DURATION</label>
				<InputField name='leaseDuration' value={formData?.leaseDuration} />
			</div>

			<div className='form-group'>
				<label>LEASE STRUCTURE</label>
				<InputField name='leaseStructure' value={formData?.leaseStructure} />
			</div>

			<div className='form-group'>
				<label>STATUS</label>
				<SelectFieldStatus
					name='retainmentStatus'
					value={formData?.retainmentStatus}
					type={formData?.retainmentStatus?.toLowerCase()}
					handleChange={handleInputChange}
					isEditable={isEditable}
					options={["retained", "released"]}
				/>
			</div>
		</>
	);
};
// eslint-disable-next-line no-unused-vars
export const InspectionInformationLease = ({
	formData,
	isEditable,
	handleInputChange,
	handleDateChange,
	formattedDate,
}) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>ASSET</label>
				<InputField name='productName' value={formData?.productName} />
			</div>

			<div className='form-group'>
				<label>LEASOR</label>
				<InputField name='leasor' value={getLeasorName(formData)} />
			</div>

			<div className='form-group'>
				<label>LEASEE</label>
				<InputField name='leasee' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>CATEGORY</label>
				<InputField name='productCategory' value={formData?.productCategory} />
			</div>

			<div className='form-group'>
				<label>SUB-CATEGORY</label>
				<InputField name='subCategory' value={formData?.subCategory} />
			</div>

			<div className='form-group'>
				<label>PRICE</label>
				<InputField name='amount' value={formData?.price} />
			</div>

			<div className='form-group'>
				<label>BRAND</label>
				<InputField name='brand' value={formData?.brand} />
			</div>

			<div className='form-group'>
				<label>MODEL</label>
				<InputField name='model' value={formData?.model} />
			</div>

			<div className='form-group'>
				<label>YEAR</label>
				<InputField name='year' value={formData?.year} />
			</div>

			<div className='form-group'>
				<label>CONDITION</label>
				<InputField name='condition' value={formData?.condition} />
			</div>

			<div className='form-group'>
				<label>COLOR</label>
				<InputField name='color' value={formData?.color} />
			</div>

			<div className='form-group'>
				<label>LEASE DURATION</label>
				<InputField name='leaseDuration' value={formData?.leaseDuration} />
			</div>

			<div className='form-group'>
				<label>LEASE STRUCTURE</label>
				<InputField name='leaseStructure' value={formData?.leaseStructure} />
			</div>

			<div className='form-group'>
				<label>WARRANTY</label>
				<InputField
					name='warranty'
					value={formData?.warranty}
					handleChange={handleInputChange}
					isEditable={isEditable}
				/>
			</div>

			<div className='form-group'>
				<label>INSPECTION ROUTINE</label>
				<SelectFieldStatus
					name='inspectionRoutine'
					value={formData?.inspectionRoutine}
					type={"success"}
					handleChange={handleInputChange}
					isEditable={isEditable}
					options={["weekly", "monthly", "bi-annually", "annually"]}
				/>
			</div>

			<div className='form-group'>
				<label>INSPECTION FEE</label>
				<InputField
					name='inspectionFee'
					value={formData?.inspectionFee}
					handleChange={handleInputChange}
					isEditable={isEditable}
				/>
			</div>

			<div className='form-group'>
				<label>LAST INSPECTED</label>
				<CustomDateField
					name='lastInspected'
					value={formattedDate}
					handleChange={handleDateChange}
					isEditable={isEditable}
				/>
			</div>

			<div className='form-group'>
				<label>STATUS</label>
				<SelectFieldStatus
					name='inspectionStatus'
					isEditable={isEditable}
					value={formData?.inspectionStatus}
					type={formData?.inspectionStatus?.toLowerCase()}
					options={["ongoing", "completed"]}
					handleChange={handleInputChange}
				/>
			</div>
		</>
	);
};

export const MaintainedInformationLease = ({
	formData,
	isEditable,
	handleInputChange,
	handleDateChange,
	formattedDate,
}) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>ASSET</label>
				<InputField name='productName' value={formData?.productName} />
			</div>

			<div className='form-group'>
				<label>LEASOR</label>
				<InputField name='leasor' value={getLeasorName(formData)} />
			</div>

			<div className='form-group'>
				<label>LEASEE</label>
				<InputField name='leasee' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>CATEGORY</label>
				<InputField name='productCategory' value={formData?.productCategory} />
			</div>

			<div className='form-group'>
				<label>SUB-CATEGORY</label>
				<InputField name='subCategory' value={formData?.subCategory} />
			</div>

			<div className='form-group'>
				<label>PRICE</label>
				<InputField name='amount' value={formData?.price} />
			</div>

			<div className='form-group'>
				<label>BRAND</label>
				<InputField name='brand' value={formData?.brand} />
			</div>

			<div className='form-group'>
				<label>MODEL</label>
				<InputField name='model' value={formData?.model} />
			</div>

			<div className='form-group'>
				<label>YEAR</label>
				<InputField name='year' value={formData?.year} />
			</div>

			<div className='form-group'>
				<label>CONDITION</label>
				<InputField name='condition' value={formData?.condition} />
			</div>

			<div className='form-group'>
				<label>COLOR</label>
				<InputField name='color' value={formData?.color} />
			</div>

			<div className='form-group'>
				<label>LEASE DURATION</label>
				<InputField name='leaseDuration' value={formData?.leaseDuration} />
			</div>

			<div className='form-group'>
				<label>LEASE STRUCTURE</label>
				<InputField name='leaseStructure' value={formData?.leaseStructure} />
			</div>

			<div className='form-group'>
				<label>WARRANTY</label>
				<InputField
					name='warranty'
					value={formData?.warranty}
					handleChange={handleInputChange}
					isEditable={isEditable}
				/>
			</div>

			<div className='form-group'>
				<label>MAINTENANCE FEE</label>
				<InputField
					name='maintenanceFee'
					value={formData?.maintenanceFee}
					handleChange={handleInputChange}
					isEditable={isEditable}
				/>
			</div>

			<div className='form-group'>
				<label>DUE DATE</label>
				<CustomDateField
					name='maintenanceDueDate'
					value={formattedDate}
					handleChange={handleDateChange}
					isEditable={isEditable}
				/>
			</div>

			<div className='form-group'>
				<label>STATUS</label>
				<SelectFieldStatus
					name='maintenanceStatus'
					value={formData?.maintenanceStatus}
					type={formData?.maintenanceStatus?.toLowerCase()}
					handleChange={handleInputChange}
					isEditable={isEditable}
					options={["ongoing", "completed"]}
				/>
			</div>
		</>
	);
};

// General
export const LeasorInformation = ({ formData }) => {
	const investors = formData?.investorsArray;

	const names = investors?.map((a) => a?.name)?.filter((a) => a !== undefined);
	const address = investors?.map((a) => a?.address)?.filter((a) => a !== undefined);
	const phone = investors?.map((a) => a?.phone)?.filter((a) => a !== undefined);

	console.log(names, address, phone);

	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>LEASOR</label>
				<InputField name='leasor' value={names?.length ? names.join(" ;") : formData?.admin} />
			</div>

			<div className='form-group'>
				<label>ADDRESS</label>
				<InputField
					name='item_address'
					value={address?.length ? address.join(" ;") : formData?.deliveryAddress}
				/>
			</div>

			<div className='form-group'>
				<label>PHONE NUMBER</label>
				<InputField name='phone_number' value={phone?.length ? phone.join(" ;") : formData?.phone_number} />
			</div>
		</div>
	);
};

export const LeaseeInformation = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>LEASEE</label>
				<InputField name='leasee' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>HOME ADDRESS</label>
				<InputField name='delivery_address' value={formData?.userId?.homeAddress} />
			</div>

			<div className='form-group'>
				<label>PHONE NUMBER</label>
				<InputField name='phone_number' value={formData?.userId?.phone} />
			</div>
		</div>
	);
};

export const SecondaryMarketInformation = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>STORE NAME</label>
				<InputField name='store_name' value={formData?.store_name} />
			</div>

			<div className='form-group'>
				<label>ADDRESS</label>
				<InputField name='store_address' value={formData?.store_address} />
			</div>

			<div className='form-group'>
				<label>PHONE NO</label>
				<InputField name='store_phone' value={formData?.store_phone} />
			</div>

			<div className='form-group'>
				<label>EMAIL ADDRESS</label>
				<InputField name='store_email' value={formData?.store_email} />
			</div>

			<div className='form-group'>
				<label>MARKET LOCATION</label>
				<InputField name='market_location' value={formData?.market_location} />
			</div>

			<div className='form-group'>
				<label>VENDORS NAME</label>
				<InputField name='vendors_name' value={formData?.vendors_name} />
			</div>
		</div>
	);
};
